import { Box, formatAmount, formatMoney, Text } from '@betty/moonlight';
import { useTranslation } from '@betty/i18n';
import { memo, useMemo } from 'react';
import { MysteryBoxItemDropType } from '../../state/items/items.types';

function ShopMisteryBoxInfoItem({
  type,
  weight,
  amount,
  freeSpinsCount,
  freeSpinsCoinValue,
  freeSpinsGameName,
}: MysteryBoxItemDropType) {
  const [t] = useTranslation('shop');

  const chanceText = useMemo(() => `${weight / 100}%`, [weight]);

  const rewardText = useMemo(() => {
    switch (type) {
      case 'CashReward':
        return amount
          ? t('shopMisteryBoxInfoCashReward', {
              amount: formatMoney(amount),
              interpolation: { escapeValue: false },
            })
          : null;
      case 'CoinsReward':
        return amount
          ? t('shopMisteryBoxInfoCoinsReward', {
              amount: formatAmount(amount),
              interpolation: { escapeValue: false },
            })
          : null;
      case 'FreeSpins':
        if (freeSpinsCount && freeSpinsCoinValue && freeSpinsGameName) {
          return t('shopMisteryBoxInfoFreeSpinsReward', {
            freeSpinsCount,
            freeSpinsBetAmount: formatMoney(freeSpinsCoinValue),
            freeSpinsGameName,
            interpolation: { escapeValue: false },
          });
        }
        return null;
      default:
        return null;
    }
  }, [type, t, amount, freeSpinsCount, freeSpinsCoinValue, freeSpinsGameName]);

  if (!rewardText) {
    return null;
  }

  return (
    <Box flexDirection="row" gap="space-500" justifyContent="space-between">
      <Box flexWrap="wrap" flex={1}>
        <Text color="darkSurfacePrimary" variant="body-s" width="100%">
          {rewardText}
        </Text>
      </Box>
      <Text color="darkSurfacePrimary" variant="body-s">
        {chanceText}
      </Text>
    </Box>
  );
}

export default memo(ShopMisteryBoxInfoItem);
